import React from 'react';
import { 
    Flex, 
    Text,
    Image,
    useMediaQuery,
    useTheme,
    Divider
} from '@chakra-ui/react';
import icon1 from '../assets/icons/caracteristicas/icon1.svg';
import icon2 from '../assets/icons/caracteristicas/icon2.svg';
import icon3 from '../assets/icons/caracteristicas/icon3.svg';

import pt from '../assets/icons/desarrollos/punto-sur.svg';
import ventura from '../assets/icons/desarrollos/ventura.svg';
import soare from '../assets/icons/desarrollos/soare.svg';
import cz from '../assets/icons/desarrollos/centro-zapopan.svg';
import ws from '../assets/icons/desarrollos/we-solares.svg';

import tel from '../assets/icons/phone.svg';
import wsp from '../assets/icons/whats.svg';

import animacion from '../assets/icons/animacion.svg';

const Caracteristicas = () => {
    const { breakpoints } = useTheme();
    const [isGreaterThanMd] = useMediaQuery(`(min-width: ${breakpoints.lg})`);

    return ( 
        <Flex flexDirection={"column"} color={"#545454"} w={"100%"} bg={"#EEEEEE"} position={"relative"}>
            <Flex justifyContent={"center"} mt={20} mb={isGreaterThanMd ? 20 : 10}>
                <Text fontSize={isGreaterThanMd ? '40px' : '20px'} fontWeight={700} color={"#302C7D"}>Nos encargamos de todo para que tú<br />no tengas que preocuparte por nada</Text>
            </Flex>
            <Flex justifyContent={"center"} alignItems={"center"} w={"100%"} mb={20} flexDirection={isGreaterThanMd ? 'row' : 'column'}>
                <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={isGreaterThanMd ? "end" : "center"}>
                    <Flex flexDirection={"column"} alignItems={"center"}>
                        <Image src={icon1} w={isGreaterThanMd ? '162px' : '110px'} h={'132px'} alt='icon1' mb={2}/>
                        <Text fontSize={isGreaterThanMd ? '20px' : '16px'} fontWeight={600} mt={isGreaterThanMd ? 10 : 0} height={isGreaterThanMd ? 'auto' : '20px'}>Formas de pago a tu medida<br /><span style={{ color: "#EEEEEE" }}>.</span><br /><span style={{ color: "#EEEEEE" }}>.</span></Text>
                    </Flex>
                </Flex>
                <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={"center"}>
                    <Flex flexDirection={"column"} alignItems={"center"}>
                        <Image src={icon2} w={isGreaterThanMd ? '198px' : '120px'} h={'123px'} alt='icon2' mb={2}/>
                        <Text fontSize={isGreaterThanMd ? '20px' : '16px'} fontWeight={600} mt={isGreaterThanMd ? 10 : 0}>Solución de espacios</Text>
                        <Text fontSize={isGreaterThanMd ? '13px' : '10px'} fontWeight={400} mt={2} textAlign={"center"}>Medimos por ti y encontramos el<br />mueble ideal para cada área</Text>
                    </Flex>
                </Flex>
                <Flex w={isGreaterThanMd ? "33%" : "100%"} justifyContent={isGreaterThanMd ? "start" : "center"}>
                    <Flex flexDirection={"column"} alignItems={"center"}>
                        <Image src={icon3} w={isGreaterThanMd ? '154px': '100px'} h={'160px'} alt='icon3'/>
                        <Text fontSize={isGreaterThanMd ? '20px' : '16px'} fontWeight={600} mt={isGreaterThanMd ? 5 : 0}>Protección vs. inflación</Text>
                        <Text fontSize={isGreaterThanMd ? '13px' : '10px'} fontWeight={400} mt={2} textAlign={"center"}>(congela el precio del equipamiento<br />seleccionado a precio actual)</Text>
                    </Flex>
                </Flex>
            </Flex>
            <Flex bg={"#fff"} flexDirection={"column"} w={"100%"}>
                <Flex flexDirection={"column"} mt={10} ml={isGreaterThanMd ? 20 : 5}>
                    <Text fontSize={isGreaterThanMd ? '36px' : '22px'} fontWeight={500} color={"#302C7D"}>
                        Firma tu contrato con Guía<br />y te REGALAMOS EL PRIMER MES<br />en tu paquete morhada.
                    </Text>
                    <Text fontSize={isGreaterThanMd ? '34px' : '20px'} fontWeight={'light'} mt={isGreaterThanMd ? 20 : 10}>Proyectos que incluyen el servicio</Text>
                    <Text fontSize={isGreaterThanMd ? '34px' : '20px'} fontWeight={700}>¡Contáctanos y conoce toda la información!</Text>
                </Flex>
                <Flex flexDirection={"column"} mt={5} ml={isGreaterThanMd ? 20 : 0} w={isGreaterThanMd ? "50%" : "100%"} pb={isGreaterThanMd ? 20 : 0}>
                    <Flex mb={isGreaterThanMd ? 5 : 0} justifyContent={"center"} alignItems={"center"} flexDirection={isGreaterThanMd ? "row" : "column"}>
                        <Image src={pt} w={'190px'} h={'122px'} mb={isGreaterThanMd ? 0 : 8} mr={isGreaterThanMd ? 20 : 5} alt='icon1'/>
                        <Image src={ventura} w={'95px'} h={'95px'} mb={isGreaterThanMd ? 0 : 8} mr={isGreaterThanMd ? 20 : 5} alt='icon2'/>
                        <Image src={soare} w={'105px'} h={'111px'} mb={isGreaterThanMd ? 0 : 8} alt='icon3'/>
                    </Flex>
                    <Flex justifyContent={"center"} alignItems={"center"} flexDirection={isGreaterThanMd ? "row" : "column"}>
                        <Image src={cz} w={'119px'} h={'102px'} mb={isGreaterThanMd ? 0 : 10} mr={isGreaterThanMd ? 20 : 5} alt='icon4'/>
                        <Image src={ws} w={'137px'} h={'89px'} mr={isGreaterThanMd ? 20 : 0} alt='icon5'/>
                    </Flex>
                </Flex>
                <Flex 
                    position={isGreaterThanMd ? "absolute" : "initial"}
                    right={2}
                    bottom={isGreaterThanMd ? 20 : 0}
                    justifyContent={isGreaterThanMd ? "end" : "center"}>
                    <Image src={animacion} w={isGreaterThanMd ? '679px' : '400px'} h={isGreaterThanMd ? '897px' : '550px'} alt='animacion'/>
                </Flex>
                <Flex pl={"3rem"} pr={"3rem"} mb={isGreaterThanMd ? 10 : 0}>
                    <Divider orientation='horizontal' />
                </Flex>
                <Flex alignItems={"center"} mb={10} color={"#302C7D"} justifyContent={"center"} flexDirection={isGreaterThanMd ? "row" : "column"}>
                    <Flex mr={isGreaterThanMd ? 10 : 0} alignItems={"center"}>
                        <Image src={tel} w={isGreaterThanMd ? '74px' : '40px'} h={'74px'} mr={5} alt='icon4'/>
                        <Text fontSize={isGreaterThanMd ? '34px' : '22px'} fontWeight={'light'}>33 1865 1363</Text>
                    </Flex>
                    <Flex ml={isGreaterThanMd ? 10 : 0} alignItems={"center"}>
                        <Image src={wsp} w={isGreaterThanMd ? '75px' : '40px'} h={'75px'} mr={5} alt='icon4'/>
                        <Text fontSize={isGreaterThanMd ? '34px' : '22px'} fontWeight={'light'}>33 2192 1781</Text>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
}
 
export default Caracteristicas;